import React from 'react';
import { Faqs } from '~/components/views/Managed/Overview/components/Faqs';
import styles from './FAQ.module.scss';
import Link from 'next/link';

export const sharedFAQs = [
    {
        question: 'What is the minimum amount I need to invest in my Trading account?',
        answer: 'In the Vinovest Marketplace there is no minimum dollar amount required to create an account.  As long as you have enough balance in your account to buy a wine that is available on the Marketplace, you can add that wine to your portfolio.'
    },
    {
        question: 'Is there a lock-up period for any wines added to my Trading portfolio?',
        answer: 'No, there is no lock-up period at all on the Marketplace.  You could even buy and sell a wine on the same day and you will not be penalized in any way.'
    },
    {
        question:
            'Can I buy single bottles on the Marketplace or do I have to purchase the wine in cases like in my Managed portfolio?',
        answer: 'Yes, on the Vinovest Marketplace we enable our investors to buy wine by the bottle instead of by the case.  This allows investors to achieve a greater degree of diversity in their portfolio at a much lower investment level.'
    },
    {
        question: 'Do I need to have a Managed portfolio to open a Trading account?',
        answer: 'Not at all, you can select which type of portfolio best suits your investment goals.  You can choose Managed, Trading or even both.  Regardless of the type of portfolio you select, you will gain access to some of the best wines in the world.'
    }
];

export const FAQ = () => {
    return (
        <div className={styles.container}>
            <h2 className={'heading-2'}>Frequently Asked Questions</h2>
            <div className={styles.wrapper}>
                <Faqs data={sharedFAQs} />
            </div>
            <Link className={styles.viewAll} href={'/help'}>
                VIEW ALL
            </Link>
        </div>
    );
};
